import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';

export const FRANCHISES_TAGS = Object.freeze({});

export const franchisesApiSlice = createApi({
  reducerPath: 'franchisesApiSlice',
  baseQuery,
  tagTypes: Object.values(FRANCHISES_TAGS),
  endpoints: (builder) => ({
    partialUpdateFranchise: builder.mutation({
      query: ({ apiManager, id, ...data }) => apiManager.partialUpdate(id, data),
    }),
  }),
});

export const { usePartialUpdateFranchiseMutation } = franchisesApiSlice;
